import { REQUEST_ABORT_IDS } from '@/constants/whitelabels';
import { useRequestSaver } from '@/hooks/RequestSaver';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getWhitelabels, resetWhitelabelsPageState } from '@/store/slices/whitelabelsSlice';
import { Paper } from '@mui/material';
import { useCallback, useEffect } from 'react';
import DataGrid from './DataGrid';

const Whitelabels = () => {
  const dispatch = useAppDispatch();
  const requestSaver = useRequestSaver();
  const { loading: loadingMe } = useAppSelector(state => state.me);
  const { whitelabels, orgs, whitelabelsRequestId, total, filters } = useAppSelector(state => state.whitelabels);

  //#region useCallback
  const fetchWhitelabels = useCallback(() => {
    dispatch(getWhitelabels({ ...requestSaver.requestSaverSetCancellation(REQUEST_ABORT_IDS.WHITELABELS) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  //#endregion

  //#region useEffect
  useEffect(() => {
    requestSaver.requestSaverAbortAll();
    return () => {
      dispatch(resetWhitelabelsPageState());
      requestSaver.requestSaverAbortAll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loadingMe) {
      fetchWhitelabels();
    }
  }, [fetchWhitelabels, loadingMe, filters.organizationIds, filters.search]);
  //#endregion

  return (
    <Paper
      className='grid grid-cols-1'
      sx={{
        margin: '30px',
        width: 'calc(100% - 60px)',
        maxWidth: 'calc(100% - 60px)',
      }}
    >
      <div className='flex w-full h-full'>
        <DataGrid
          rows={whitelabels}
          orgs={orgs}
          loading={!!whitelabelsRequestId}
          fetchWhitelabels={fetchWhitelabels}
          rowCount={total}
        />
      </div>
    </Paper>
  );
};

export default Whitelabels;
